import { ZapMetadataStep } from "../types";

export const PATH_ACTION = "parallel_paths";

/** API gives us EngineAPI for paths, but we convert it to BranchingAPI in collectUniqueAppsRecursive function to get the correct icons to show up */
export const isPathStep = (step: ZapMetadataStep) =>
  step.type === "run" &&
  (step.app === "EngineAPI" || step.app === "BranchingAPI") &&
  step.action === PATH_ACTION;
